import Link from 'next/link';

import { Typography } from 'lighthouse';

import { ShelfSeeAllCardProps } from './models';

import { ArrowLeft2, SearchNormal1 } from 'iconsax-react';

export const ShelfSeeAllCard = ({ href, label, total, dark = false }: ShelfSeeAllCardProps) => (
    <Link
        href={href}
        prefetch={false}
        className={`flex h-full flex-row items-center gap-3 rounded-2xl border border-dashed p-4 text-right no-underline transition-colors
            focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-secondary motion-reduce:transition-none
            md:min-h-48 md:flex-col md:justify-center md:gap-4 md:p-6 md:text-center ${
                dark
                    ? 'border-white/30 bg-white/5 hover:border-white/60 hover:bg-white/10'
                    : 'border-primary/40 bg-primary/5 hover:border-primary hover:bg-primary/10'
            }`}>
        <span
            className={`flex h-12 w-12 shrink-0 items-center justify-center rounded-full shadow-sm md:h-14 md:w-14 ${
                dark ? 'bg-white/15 text-white' : 'bg-white text-primary'
            }`}>
            <SearchNormal1 size={24} color='currentColor' variant='Bulk' aria-hidden />
        </span>
        <span className='flex min-w-0 flex-1 flex-col gap-1 md:flex-none'>
            <Typography
                variant='subtitle1'
                component='span'
                color={dark ? 'whiteHighEmphasis' : 'blackHighEmphasis'}
                className={`font-bold leading-7 ${dark ? 'text-white' : ''}`}>
                مشاهده همهٔ {label}
            </Typography>
            {total > 0 && (
                <Typography
                    variant='caption'
                    component='span'
                    color={dark ? 'whiteMediumEmphasis' : 'blackMediumEmphasis'}
                    className={`leading-6 ${dark ? 'text-white/70' : ''}`}>
                    {total.toLocaleString('fa-IR')} محصول از فروشندگان مختلف
                </Typography>
            )}
        </span>
        <ArrowLeft2 size={20} color='currentColor' aria-hidden className={`shrink-0 md:hidden ${dark ? 'text-white' : 'text-secondary'}`} />
        <span className={`hidden items-center gap-1 md:inline-flex ${dark ? 'text-brandYellow' : 'text-secondary'}`}>
            <Typography variant='body2' component='span' className='font-bold text-current'>
                دیدن لیست کامل
            </Typography>
            <ArrowLeft2 size={16} color='currentColor' aria-hidden />
        </span>
    </Link>
);
